/* global axios */
import ApiClient from './ApiClient';

class WabaTemplatesAPI extends ApiClient {
  constructor() {
    super('waba_templates', { accountScoped: true });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }

  submit(id) {
    return axios.post(`${this.url}/${id}/submit`, { confirmed: true });
  }
}

export default new WabaTemplatesAPI();
